angular.module('aprima-bridge').factory('WebBridge',
    ['$rootScope', '$log', '_',
        function ($rootScope, $log, _) {
            'use strict';
            
            var getLog = function() {
                return $log.delegate || $log;    
            };
            
            var _updateSettings = function (settings) {
                getLog().info('calling web bridge: settings = ' + JSON.stringify(settings));
            };

            var _modalAlert = function (alert) {
                getLog().error('WebBridge.createModalAlert  ----------');
                getLog().error('alert.title  = ' + alert.title);
                getLog().error('alert.message = ' + alert.message);
            };

            return {
                onNavigate: angular.noop,
                trackPageChange: function(location) {
                    getLog().debug('Page Change: ' + _.pad(location, 30));
                },
                trackEvent: function(category, action, label, value) {
                    getLog().debug('Event: ' + _.pad(category, 20) + ' | ' + _.pad(action, 20) + ' | ' + _.pad(label, 20) + ' | ' + _.pad(value, 20));
                },
                trackException: function(message) {
                    getLog().debug('Exception: ' + message);
                },
                trackTiming: function(category, label, timingValue, page) {
                    getLog().debug('Timing: ' + _.pad(page, 30) + ' | ' + _.pad(category, 7) + ' | ' + _.pad(label, 30) + ' | ' + _.pad(timingValue, 5) + 'ms');
                },
              
                changeUserInfo: angular.noop,
                setupPage: angular.noop,
                setHeaderMode: angular.noop,
                goBack: angular.noop,
                logoff: angular.noop,
                pageFinished: angular.noop,
                pickMedia: angular.noop,
                updateSettings: _updateSettings,
                createModalAlert: _modalAlert,
                closeSearchHeader: angular.noop,
                updateBadges: angular.noop,
                updatePageIndicator: angular.noop,
                overriddenMessages: angular.noop,
                debugModeToggled: angular.noop,
                updateInactivityTimeout: angular.noop,
                scanBarcode: angular.noop,

                on: function (event, $scope, fn) {
                    //handles events received from the getBridge() and removes the event when the scope is destroyed
                    var handlerForScope = function (e, args) {

                        function handler () {
                            fn(args);
                        }

                        if($scope && $scope.$evalAsync) {
                            $scope.$evalAsync(function() {
                                handler();
                            });
                        }
                        else {
                            handler();
                        }
                    };

                    var removerEventListener = $rootScope.$on(event, handlerForScope);

                    if($scope){
                        $scope.$on('$destroy', function () {
                            getLog().info('removing listener from bridge due to $scope.$destroy event');
                            removerEventListener();
                            $scope = fn = null;
                        });
                    }

                    return removerEventListener;
                },
                //only for the webbridge
                fireEvent: function (event, data) {
                    $rootScope.$broadcast(event, data);                   
                }                
            };
        }]);
